import { Box } from '@mui/material';
import React from 'react';
import { AiderScreenLayoutProps } from '../layout';

const AiderScreen: React.FC<AiderScreenLayoutProps> = (props) => {
  const { sticky, top } = props;
  const rootSx = [
    { maxWidth: 400, flex: 1 },
    ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
  ];
  if (sticky) {
    return (
      <Box sx={rootSx}>
        <Box
          sx={(theme) => {
            const height_normal =
              theme.mixins.toolbar?.height ||
              theme.mixins.toolbar?.minHeight ||
              0;
            const top_normal = +height_normal + (top || 0);
            return {
              position: 'sticky',
              top: top_normal,
              overflow: 'auto',
              maxHeight: `calc(100vh - ${top_normal}px)`,
            };
          }}
        >
          <Box>{props.children}</Box>
        </Box>
      </Box>
    );
  }
  return <Box sx={rootSx}>{props.children}</Box>;
};

export default AiderScreen;
